export function getProcessingStage(status) {
    switch (status) {
        case "uploaded":
            return "1";
        case "in_progress":
        case "checking_file":
        case "valid":
            return "2";
        case "invalid":
            return "2";
        case "error":
            return "2";
        case "xsd_checking":
        case "parsing_data_to_csv":
        case "validate_csv":
            return "4";
        case "saving_to_db":
            return "5";
        case "calculating_tribal":
            return "6";
        case "calculating_kpis":
            return "7";
        case "test_running":
            return "8";
        case "imported":
            return "9";
        default:
            return "0";
    }
}

export function getFileSubmittedStatus(submitted) {
    switch (submitted) {
        case 1:
            return { color: "main", family: "success" };
        case 0:
            return { color: "main", family: "destructive" };
        default:
            return { color: "main", family: "destructive" };
    }
}
export function getFileStatus(status) {
    switch (status) {
        case "imported":
            return { color: "main", statusFamily: "success" };
        case "invalid":
            return { color: "main", statusFamily: "destructive" };
        case "submitted":
            return { color: "300", statusFamily: "grey" };
        case "in_progress":
        case "checking_file":
        case "valid":
        case "xsd_checking":
        case "parsing_data_to_csv":
        case "validate_csv":
        case "saving_to_db":
        case "calculating_tribal":
        case "calculating_kpis":
        case "test_running":
            return { color: "main", statusFamily: "warning" };
        default:
            return { color: "300", statusFamily: "grey" };
    }
}

export function getMergeStatus(mergeStatus) {
    switch (mergeStatus) {
        case 0:
        case null:
        case 3:
        case 4:
        case 5:
            return {
                mergeStatusColor: "not_started",
                mergeStatusMessage: "merge_not_started",
                family: "grey",
                color: "300",
            };
        case 1:
            return {
                mergeStatusColor: "complete",
                mergeStatusMessage: "merge_complete",
                family: "success",
                color: "main",
            };
        case 2:
            return {
                mergeStatusColor: "in_progress",
                mergeStatusMessage: "merge_in_progress",
                family: "warning",
                color: "main",
            };
        default:
            return {
                mergeStatusColor: "error",
                mergeStatusMessage: "Error",
                family: "error",
                color: "main",
            };
    }
}
